module.exports = __webpack_public_path__ + "static/media/selected-feedback-thumbs-down.1af69914.svg";